/* eslint-disable no-restricted-imports */
import { LinkProps } from 'react-router-dom';
import {
  CardActionArea as MuiCardActionArea,
  CardActionAreaProps as MuiCardActionAreaProps,
} from '@material-ui/core';
import React from 'react';

/**
 * Cards contain content and actions about a single subject.
 *
 * ```js
 * import { Card } from 'ui';
 * ```
 */
export interface CardActionAreaProps extends MuiCardActionAreaProps {
  href?: string;
  to?: LinkProps['to'];
  component?: React.ElementType;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CardActionArea = React.forwardRef<any, CardActionAreaProps>((props, ref) => {
  return <MuiCardActionArea {...props} ref={ref} />;
});
export default CardActionArea;
